<ws-modal-wrapper (cancel)="cancel()"
                  [hideFooter]="true"
                  [loading]="!descriptorCategories"
                  headerLabel="Browse Characteristics">
    @if (descriptorCategories) {
        <tabset class="column-picker-tabs">
            @for (category of descriptorCategories; track category) {
                <tab>
                    <ng-template tabHeading>
                        {{ category.name }}
                        @if (category.checkedCount) {
                            <span class="badge text-bg-info ms-1">{{ category.checkedCount }}</span>
                        }
                    </ng-template>
                    <div class="d-flex px-3" style="flex-flow: column wrap; height: 500px; overflow-x: auto;">
                        @for (descriptor of category.descriptors; track descriptor) {
                            <div class="checkbox mt-0 me-3">
                                <label>
                                    <input (change)="descriptorClicked(descriptor, category, $event)"
                                           [checked]="isDescriptorChecked(descriptor)"
                                           type="checkbox"> {{ descriptor.name }}
                                </label>
                            </div>
                        }
                    </div>
                </tab>
            }
        </tabset>
    }

    <ng-container modal-footer>
        <div class="d-flex justify-content-between">
            <button (click)="clearSelection()" class="ace-btn btn-secondary mx-1" type="button">Clear Selection</button>
            <div>
                <button (click)="save()" [disabled]="!descriptorsToAdd.length" class="ace-btn btn-primary mx-1"
                        type="button">
                    Add @if (descriptorsToAdd.length) {
                    <span>({{ descriptorsToAdd.length }})</span>
                }
                </button>
                <button (click)="cancel()" class="ace-btn btn-secondary mx-1" type="button">Cancel</button>
            </div>
        </div>
    </ng-container>
</ws-modal-wrapper>

